import React from "react";

export function Card({ className = "", hover = false, children, ...props }) {
  return (
    <div
      className={`bg-white rounded-2xl border border-ink-100 shadow-[0_1px_2px_rgba(20,22,29,0.04),0_8px_24px_-8px_rgba(20,22,29,0.10)] ${
        hover
          ? "transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_4px_8px_rgba(20,22,29,0.06),0_16px_32px_-8px_rgba(20,22,29,0.16)]"
          : ""
      } ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function Badge({ tone = "brand", className = "", children }) {
  const tones = {
    brand: "bg-brand-50 text-brand-700",
    ink: "bg-ink-100 text-ink-700",
    success: "bg-emerald-50 text-emerald-700",
    warning: "bg-amber-50 text-amber-700",
    sky: "bg-sky-50 text-sky-700",
    dark: "bg-ink-900 text-white",
  };
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${tones[tone]} ${className}`}>
      {children}
    </span>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, action, className = "" }) {
  return (
    <div className={`flex flex-wrap items-end justify-between gap-4 ${className}`}>
      <div>
        {eyebrow && (
          <p className="text-xs font-bold tracking-[0.14em] text-brand-600 uppercase mb-2">{eyebrow}</p>
        )}
        <h2 className="text-2xl md:text-[28px] font-bold text-ink-900 tracking-tight">{title}</h2>
        {subtitle && <p className="mt-1.5 text-ink-500 text-[15px]">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
